import { useSelector, useDispatch } from 'react-redux';
import { 
  setSearchQuery, 
  setSelectedCategory, 
  applyFilters, 
  clearFilters, 
  applyCategoryFilter, 
  applySearchFilter,
  setCategories,
  setPriceRanges,
  setServices,
  setHasPromotions,
  setIsOpen,
  updateFilters
} from '../store/slices/searchFiltersSlice';

export const useSearchFilters = () => {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.searchFilters);

  const actions = {
    setSearchQuery: (query) => dispatch(setSearchQuery(query)),
    setSelectedCategory: (category) => dispatch(setSelectedCategory(category)),
    applyFilters: (filters) => dispatch(applyFilters(filters)),
    clearFilters: () => dispatch(clearFilters()),
    applyCategoryFilter: (category) => dispatch(applyCategoryFilter(category)),
    applySearchFilter: (query) => dispatch(applySearchFilter(query)),
    setCategories: (categories) => dispatch(setCategories(categories)),
    setPriceRanges: (priceRanges) => dispatch(setPriceRanges(priceRanges)),
    setServices: (services) => dispatch(setServices(services)),
    setHasPromotions: (hasPromotions) => dispatch(setHasPromotions(hasPromotions)),
    setIsOpen: (isOpen) => dispatch(setIsOpen(isOpen)),
    updateFilters: (filters) => dispatch(updateFilters(filters)),
  };

  return {
    ...filters,
    ...actions,
  };
};

export default useSearchFilters;
